<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Platform Order Item
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col" >
                    <template v-if="orderItem">
                      <div class="form-group row">
                        <label for="marketplace_name" class="col-sm-3 col-form-label">
                          {{ $t('marketplace.marketplace_name') }}: {{ orderItem.platform }}
                        </label>
                        <label for="platform_order_id" class="col-sm-5 col-form-label">
                          {{ $t('marketplace.rma_product.platform_order_id') }}: {{ orderItem.platform_order_id }}
                        </label>
                      </div>
                      <div class="form-group row">
                        <label for="order_item_id" class="col-sm-3 col-form-label">
                          {{ $t('marketplace.rma_product.order_item_id') }}: {{ orderItem.order_item_id }}
                        </label>
                        <label for="imei_code" class="col-sm-5 col-form-label">
                          {{ $t('marketplace.rma_product.imei_code') }}: {{ orderItem.imei_code }}
                        </label>
                      </div>
                    </template>
                    <template v-else>
                      <div class="form-group row">
                        <label for="imei_code" class="col-sm-2 col-form-label">
                          {{ $t('marketplace.rma_product.imei_code') }}
                        </label>
                        <div class="col-sm-6">
                          <input v-model="rmaProduct.imei_code" type="text" name="imei_code" class="form-control" />
                        </div>
                      </div>
                    </template>
                      <div class="form-group row">
                        <label for="product_name" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.product_name') }}</label>
                        <div class="col-sm-6">
                          <textarea rows="4" v-model.trim="rmaProduct.product_name" type="text" name="product_name" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="qty" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.qty') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.qty" type="number" name="qty" class="form-control" />
                        </div>
                        <label for="return_tracking_number" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.return_tracking_number') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.return_tracking_number" type="text" name="return_tracking_number" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="type" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.type') }}</label>
                        <div class="col-sm-3">
                           <select class="form-control" v-model="rmaProduct.type">
                            <option value="1" key="2">RMA</option>
                            <option value="2" key="3"> RMA - Ageing</option>
                          </select>
                        </div>
                        <label for="return_requested_at" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.return_requested_at') }}</label>
                        <div class="col-sm-3">
                          <input v-model="returnRequestedDate" type="date" name="return_requested_at" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="cost" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.cost') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.cost" type="number" name="cost" class="form-control" />
                        </div>
                        <label for="selling_price" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.selling_price') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.selling_price" type="number" name="selling_price" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.remark') }}</label>
                        <div class="col-sm-6">
                           <textarea rows="4" v-model.trim="rmaProduct.remark" type="text" name="remark" class="form-control" />
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-2">
                      <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                      <b-button v-show="!showLoadingPanel" type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.rma_product.submit') }}</b-button>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'
import moment from 'moment'

export default {
  name: 'AddRmaProductForm',
  props: {
    orderItem: {
      type: Object
    },
    createType:{
      type: String
    },
    callback: {
      type: Function
    }
  },
  mounted () {
    this.axios.get('/marketplace/rma-product/create').then(response => {
      this.exchangeRates = response.data.exchange_rates
    }).catch(error => {
      console.log(error)
    })
  },
  components: {
    loadingPanel
  },
  data () {
    return {
      exchangeRates:[],
      rmaProduct: {
        marketplace_order_item_id: 0 ,
        product_name: '',
        imei_code: '',
        return_tracking_number: '',
        type: "1",
        qty: 1,
        cost: null,
        selling_price: null,
        remark: '',
      },
      returnRequestedDate: moment().format('YYYY-MM-DD'),
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  watch: {
    orderItem (val) {
      var exchangeRate = this.exchangeRates?.find(item => item.from_currency == 'EUR')
      var sellingPrice = null
      if (exchangeRate) {
        sellingPrice = (exchangeRate.rate * val.item_price).toFixed(2)
      }
      this.rmaProduct = {
        marketplace_order_item_id: val.id,
        product_name: val.title,
        qty: 1,
        type: 1,
        selling_price: sellingPrice,
        cost: null,
        remark:''
      }
    }
  },
  methods: {
    handleSubmit () {
      // create store
      this.showLoadingPanel = true
      this.axios.post('/marketplace/rma-product', {
          ...this.rmaProduct,
          create_type: this.createType,
          return_requested_at: this.returnRequestedDate,
        }).then(response => {
        this.showLoadingPanel = false
        this.showAlert('success', this.$t('marketplace.rma_product.success_message'))
        this.message = response.data
        setTimeout(() => {
          this.showDismissibleAlert = false
          this.callback()
        }, 2000);

      }).catch(error => {
        this.showLoadingPanel = false
         if(error.data.validations && Object.keys(error.data.validations).length > 0){
            let  errorMessage = ""
            for(var key of Object.keys(error.data.validations)) {
              errorMessage = key +": "
              error.data.validations[key].forEach(element => {
                errorMessage += element
              });
            }
            this.showAlert('danger', errorMessage)
          }
          if(error.data.message){
              this.showAlert('danger', error.data.message)
          }
      })
    },
    format (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  }
}
</script>
